import Utility from "../../../helpers/paymentHelpers/utility";
import get from "lodash/get";
import LocalStorageFunc from "../../../helpers/paymentHelpers/localStorageFunc";
import {
  RESPONSE,
  common,
  PAYMENT_METHOD,
  wallet,
} from "../../../helpers/paymentHelpers/paymentConstants";
import Headers from "../../../config/headers";
import ApiCalls from "../../../config/paymentConfig/apiCalls";
import {
  keyMapsAction,
  keyMapsMutation,
} from "../../../helpers/paymentHelpers/storeKeys";
// import ampUtility from "../../../helpers/paymentHelpers/amplitude/ampUtility";

export default {
  namespaced: true,
  state: {
    isCartDataLoaded: false,
    cartData: {},
    calculations: [],
    validItems: [],
    isChangedPromoCodeApplied: false,
    isExplicitPromoAvailable: false,
    isNotApplicablePromoActive: false,
  },
  getters: {},
  mutations: {
    updateNotApplicablePromoActive(state, payload) {
      state.isNotApplicablePromoActive = payload;
    },
    updateIsChangedPromoCodeApplied(state, payload) {
      state.isChangedPromoCodeApplied = payload;
    },
    updateCartDataLoaded(state, payload) {
      state.isCartDataLoaded = payload;
    },
    updateCartData(state, payload) {
      state.cartData = payload;
    },
    updatecalculations(state, payload) {
      state.calculations = payload;
    },
    updateValidItems(state, payload) {
      state.validItems = payload;
    },
    updateIsExplicitPromoAvailable(state, payload) {
      state.isExplicitPromoAvailable = payload;
    },
  },
  actions: {
    getCartData({ commit, state, dispatch, rootState }, payload) {
      try {
        const cartDataObj = rootState.PriceDetail.cartData || {};
        if (cartDataObj.calculations && cartDataObj.calculations.length > 0) {
          commit("updatecalculations", cartDataObj.calculations);
          cartDataObj.displayNetPrice =
            cartDataObj?.baseCalculationsMap?.grand_total?.roundedValue;
          commit("updateCartData", cartDataObj);
          commit("updateValidItems", get(cartDataObj, "validItems", []));
          //
          const explicitPromoObj = get(cartDataObj, "explicitPromo", false);
          if (
            explicitPromoObj &&
            explicitPromoObj.paymentOptions &&
            explicitPromoObj.paymentOptions.length > 0
          ) {
            commit("updateIsExplicitPromoAvailable", true);
            dispatch(keyMapsAction.BIN_OFFER_SAVE_PAYMENT_API, cartDataObj, {
              root: true,
            });
          }
          //set display net price
          const displayPrice = get(
            cartDataObj,
            "baseCalculationsMap.grand_total.roundedValue",
            LocalStorageFunc.getDispalyNetPrice()
          );
          commit(keyMapsMutation.UPDATE_DISPALY_PRICE, displayPrice, {
            root: true,
          });
        } else {
          //redirect to cart
          console.log("No cart data - redirect to cart");
        }
      } catch (err) {
        console.log("ERROR in GET CART DATA", err);
      } finally {
        console.log("finally in GET CART DATA");
        commit("updateCartDataLoaded", true);
      }
    },
    getCartApiCall({ commit, state, dispatch, rootState }, payload) {
      try {
        const loyaltyInfo = Utility.tryJsonParse(
          LocalStorageFunc.getLoyaltyInfo()
        );
        const isUserEnrolled =
          get(loyaltyInfo, "enrollmentStatus", "").toLowerCase() === "enrolled";
        const loyaltyCardCode = get(loyaltyInfo, "loyaltyCardCode", "");
        const isWalletUsed = LocalStorageFunc.getIsWalletUsed();
        const tipCartVariant = Utility.getSessionStorageValue(
          "VWO_TIPCART_VARIANT"
        );
        let paymentModeTemp = get(
          rootState,
          "PaymentSubmit.paymentModeTemp",
          {}
        );
        const isCarryBagSelected =
          Utility.getSessionStorageValue("CARRY_BAG_CHECKBOX_SELECTED") ||
          false;
        const tipAmt = get(rootState, "PriceDetail.cartData.tip.tipAmount", 0);
        let queryObj = {
          items: Utility.checkCrustSizeId(state.validItems),
          optedOptionalCharges: [
            {
              chargeTypeCode: "K",
              selected: isCarryBagSelected,
            },
          ],
          tip: {
            tipAmount: tipAmt,
            tipRemoved: false,
          },
        };
        if (payload.promoCode) {
          queryObj.explicitPromo = {
            promoCode: payload.promoCode,
          };
        }
        if (isUserEnrolled) {
          queryObj.loyaltyCardCode = loyaltyCardCode;
        }
        queryObj.isWalletUsed = isWalletUsed;
        const dataObj = {
          cartId: LocalStorageFunc.cartId(),
          queryObj,
        };
        const headersObj = {
          ...Headers(),
          isWalletUsed,
          tip_variant: tipCartVariant || "NA",
          selected_payment_id: paymentModeTemp.paymentId,
        };
        ApiCalls.GET_CART_DATA_API({
          headers: headersObj,
          payload: dataObj,
        })
          .then(function (res) {
            if (res?.data) {
              if (res.data.status === RESPONSE.SUCCESS) {
                let cartD = res.data;
                if (
                  cartD.explicitPromo?.errors &&
                  cartD.explicitPromo?.errors?.length > 0
                ) {
                  let errMsg = get(
                    cartD.explicitPromo,
                    "errors[0].displayMsg",
                    common.internalServerError
                  );

                  let errData = {
                    bodyMsg: errMsg,
                    headerMsg: "",
                    rightCTAText: "Okay got it",
                  };
                  dispatch("PaymentSubmit/openErrorModalFun", errData, {
                    root: true,
                  });
                } else {
                  // Utility.saveCartSuccess(cartD);
                  const explicitPromoObj = get(cartD, "explicitPromo", false);
                  if (
                    explicitPromoObj &&
                    explicitPromoObj.paymentOptions &&
                    explicitPromoObj.paymentOptions.length > 0
                  ) {
                    commit("updateIsExplicitPromoAvailable", true);
                    if (!rootState.CreditDebit.PayUsingOtherPaymentModeTrue) {
                      dispatch(
                        keyMapsAction.BIN_OFFER_SAVE_PAYMENT_API,
                        cartD,
                        { root: true }
                      );
                    }
                  } else {
                    commit("updateIsExplicitPromoAvailable", false);
                    commit(
                      keyMapsMutation.UPDATE_PAY_USING_OTHER_PAYMENT_MODE,
                      true,
                      { root: true }
                    );
                  }
                  if (
                    res?.data?.baseCalculationsMap?.grand_total?.roundedValue
                  ) {
                    cartD.displayPriceWithoutDiscount =
                      res?.data?.baseCalculationsMap?.grand_total?.roundedValue;
                    cartD.displayNetPrice =
                      res?.data?.baseCalculationsMap?.grand_total?.roundedValue;
                  }
                  const displayPrice = get(
                    cartDataObj,
                    "baseCalculationsMap.grand_total.roundedValue",
                    LocalStorageFunc.getDispalyNetPrice()
                  );
                  commit(keyMapsMutation.UPDATE_DISPALY_PRICE, displayPrice, {
                    root: true,
                  });
                  commit("updatecalculations", cartD.calculations);
                  commit("updateCartData", cartD);
                  commit("updateValidItems", get(cartD, "validItems", []));
                  commit("Global/updateDisplayPrice", displayPrice, {
                    root: true,
                  });
                }

                //in the case not applicable remove promo we have to call submit call again
                if (state.isNotApplicablePromoActive) {
                  dispatch(keyMapsAction.INIT_PLACE_ORDER, {}, { root: true });

                  //after the init call we set active key as false
                  state.isNotApplicablePromoActive = false;
                } else {
                  // dispatch(keyMapsAction.OTHER_PAYMENT_OPTION_API, {}, { root: true });
                }
              } else {
                let errMsg = common.internalServerError;
                if (res?.data?.errors)
                  errMsg = get(
                    res.data,
                    "errors[0].displayMsg",
                    common.internalServerError
                  );
                const errData = {
                  bodyMsg: errMsg,
                  headerMsg: "",
                  rightCTAText: common.ok,
                };
                dispatch("PaymentSubmit/openErrorModalFun", errData, {
                  root: true,
                });
              }
            } else if (res?.errors) {
              const err = get(res, "errors[0].", "");
              const errData = {
                bodyMsg: err.displayMsg || "",
                headerMsg: err.header || "",
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch("PaymentSubmit/openErrorModalFun", errData, {
                root: true,
              });
            } else if (res?.error) {
              const errData = {
                bodyMsg: res.message || "",
                headerMsg: "",
                rightCTAText: common.ok,
              };
              dispatch("PaymentSubmit/openErrorModalFun", errData, {
                root: true,
              });
            }
          })
          .catch(function (error) {
            console.log("ERROR in Put cart Data... 101", error);
            const err = get(error, "errors[0]", "");
            const errData = {
              bodyMsg: err.displayMsg || "",
              headerMsg: err.header || "",
              rightCTAText: err.btnMsg || "",
            };
            dispatch("PaymentSubmit/openErrorModalFun", errData, {
              root: true,
            });
          });
      } catch (err) {
        console.error("ERROR in Put cart Data", err);
      } finally {
        commit("PaymentSubmit/updateProgressBarOnOrderSubmit", false, {
          root: true,
        });
      }
    },
    applyPromo({ commit, state, dispatch }, payload) {
      try {
        commit("PaymentSubmit/updateProgressBarOnOrderSubmit", true, {
          root: true,
        });
        const isMiniApp = Utility.checkIfIsMiniApp();
        const dataObj = {
          promoCode: payload.promoCode,
          cartId: LocalStorageFunc.cartId(),
          isMiniApp,
        };
        ApiCalls.APPLY_CART_PROMO({
          headers: Headers(),
          payload: dataObj,
        })
          .then(function (res) {
            if (res?.data) {
              if (res.data.status === RESPONSE.SUCCESS) {
                dispatch("getCartApiCall", payload);
                commit("updateIsChangedPromoCodeApplied", true);
                dispatch(
                  keyMapsAction.SET_PAYMENT_MODE_TEMP_ACTION,
                  payload.cardObj || {},
                  { root: true }
                );
                dispatch(
                  keyMapsAction.OTHER_PAYMENT_OPTION_API,
                  { origin: "applyPromo" },
                  { root: true }
                );
              } else {
                let errMsg = common.internalServerError;
                if (res?.data?.errors)
                  errMsg = get(
                    res.data,
                    "errors[0].displayMsg",
                    common.internalServerError
                  );
                const errData = {
                  bodyMsg: errMsg,
                  headerMsg: "",
                  isPopOpen: true,
                };
                dispatch("PaymentSubmit/openErrorModalFun", errData, {
                  root: true,
                });
                // shimmer for savedpayment apply offer button promo code
                commit(
                  "ErrorModal/updateApplyOfferShim",
                  { code: "", payload: false },
                  { root: true }
                );
              }
            } else if (res?.errors) {
              const err = get(res, "errors[0].", "");
              const errData = {
                bodyMsg: err.displayMsg || "",
                headerMsg: err.header || "",
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch("PaymentSubmit/openErrorModalFun", errData, {
                root: true,
              });
              // shimmer for savedpayment apply offer button promo code
              commit(
                "ErrorModal/updateApplyOfferShim",
                { code: "", payload: false },
                { root: true }
              );
            } else if (res?.error) {
              const errData = {
                bodyMsg: res.message || "",
                headerMsg: "",
                rightCTAText: common.ok,
              };
              dispatch("PaymentSubmit/openErrorModalFun", errData, {
                root: true,
              });
              // shimmer for savedpayment apply offer button promo code
              commit(
                "ErrorModal/updateApplyOfferShim",
                { code: "", payload: false },
                { root: true }
              );
            }
          })
          .catch(function (error) {
            console.log("ERROR in Apply Promo Code.... 101", error);
            const err = get(error, "errors[0]", "");
            const errData = {
              bodyMsg: err.displayMsg || "",
              headerMsg: err.header || "",
              rightCTAText: err.btnMsg || common.ok,
            };
            dispatch("PaymentSubmit/openErrorModalFun", errData, {
              root: true,
            });
            // shimmer for savedpayment apply offer button promo code
            commit(
              "ErrorModal/updateApplyOfferShim",
              { code: "", payload: false },
              { root: true }
            );
          });
      } catch (err) {
        console.error("ERROR in apply promo code", err);
      } finally {
        commit("PaymentSubmit/updateProgressBarOnOrderSubmit", false, {
          root: true,
        });
      }
    },
    removePromo({ commit, state, dispatch }, payload) {
      try {
        commit("PaymentSubmit/updateProgressBarOnOrderSubmit", true, {
          root: true,
        });
        const isWalletUsed = LocalStorageFunc.getIsWalletUsed();
        const tipCartVariant = Utility.getSessionStorageValue(
          "VWO_TIPCART_VARIANT"
        );
        const isMiniApp = Utility.checkIfIsMiniApp();
        const dataObj = {
          promoCode: payload.promoCode,
          cartId: LocalStorageFunc.cartId(),
          isMiniApp,
        };
        const headersObj = {
          ...Headers(),
          isWalletUsed,
          tip_variant: tipCartVariant || "NA",
        };
        ApiCalls.REMOVE_CART_PROMO({
          headers: headersObj,
          payload: dataObj,
        })
          .then(function (res) {
            if (res?.data) {
              if (res.data.status === RESPONSE.SUCCESS) {
                dispatch("getCartApiCall", {});
                dispatch(
                  keyMapsAction.OTHER_PAYMENT_OPTION_API,
                  { origin: "removePromo" },
                  { root: true }
                );
              } else {
                let errMsg = common.internalServerError;
                if (res?.data?.errors)
                  errMsg = get(
                    res.data,
                    "errors[0].displayMsg",
                    common.internalServerError
                  );
                const errData = {
                  bodyMsg: errMsg,
                  headerMsg: "",
                  rightCTAText: common.ok,
                };
                dispatch("PaymentSubmit/openErrorModalFun", errData, {
                  root: true,
                });
              }
            } else if (res?.errors) {
              const err = get(res, "errors[0]", "");
              const errData = {
                bodyMsg: err.displayMsg || "",
                headerMsg: err.header || "",
                rightCTAText: err.btnMsg || common.ok,
              };
              dispatch("PaymentSubmit/openErrorModalFun", errData, {
                root: true,
              });
            } else if (res?.error) {
              const errData = {
                bodyMsg: res.message || "",
                headerMsg: "",
                rightCTAText: common.ok,
              };
              dispatch("PaymentSubmit/openErrorModalFun", errData, {
                root: true,
              });
            }
          })
          .catch(function (error) {
            console.log("ERROR in Remove Promo Code.... 101", error);
            const err = get(error, "errors[0]", "");
            const errData = {
              bodyMsg: err.displayMsg || "",
              headerMsg: err.header || "",
              rightCTAText: err.btnMsg || common.ok,
            };
            dispatch("PaymentSubmit/openErrorModalFun", errData, {
              root: true,
            });
          });
      } catch (err) {
        console.error("ERROR in remove promo code", err);
      } finally {
        commit("PaymentSubmit/updateProgressBarOnOrderSubmit", false, {
          root: true,
        });
      }
    },
    useWallet({ state, dispatch }, payload) {
      const { type = {}, paymtMode = {} } = payload || {};
      if (get(paymtMode, "paymentId", "") !== PAYMENT_METHOD.CITRUS_WALLET) {
        let pType = {
          ...type,
          name: PAYMENT_METHOD.CITRUS_WALLET,
          label: wallet.headerText,
          paymentId: PAYMENT_METHOD.CITRUS_WALLET,
          status: "E",
          paymentMode: PAYMENT_METHOD.CITRUS_WALLET,
        };
        /**
         * When using the wallet fully,
         */
        if (paymtMode && paymtMode !== PAYMENT_METHOD.CITRUS_WALLET) {
          LocalStorageFunc.setPreviousPaymentMode(paymtMode || {});
        }
        dispatch(keyMapsAction.SET_PAYMENT_MODE_TEMP_ACTION, pType || {}, {
          root: true,
        });
      }
    },
    checkIfIsWalletUsed({ state, commit, dispatch }, payload) {
      const cartInfo = payload;
      const isWalletUsed = LocalStorageFunc.getIsWalletUsed();
      const strikePrice = get(cartInfo, "strikePrice", null);
      const walletErrors = get(cartInfo, "wallet.errors.length", 0);
      const storagePaymentMode = LocalStorageFunc.getPaymentOfferMode() || {};
      const storagePaymentName = get(storagePaymentMode, "name", "");
      const walletBalance = get(cartInfo, "wallet.totalBalance", 0);
      const canWalletBeUsed = isWalletUsed && walletBalance > 0;
      const isWalletFullyUsed = canWalletBeUsed && strikePrice === 0;
      const canWalletBeFullyUsed =
        isWalletFullyUsed && cartInfo && !walletErrors;

      let customPiggyBankPaymentMode = {
        name: "",
        index: 1,
        label: "",
        paymentId: "",
        status: "E",
        paymentMode: "",
        img_url: "",
      };

      if (canWalletBeFullyUsed) {
        dispatch("useWallet", {
          type: customPiggyBankPaymentMode,
          paymtMode: storagePaymentMode,
        });
      } else if (canWalletBeUsed) {
        const priceToBePaid = strikePrice;
        const imageUrl =
          storagePaymentName === PAYMENT_METHOD.CITRUS_WALLET
            ? "wallet_icon"
            : get(storagePaymentMode, "img_url", "");
        const label = get(storagePaymentMode, "label", "");
        const modeId = get(storagePaymentMode, "paymentId", "");
        const labelToBeDisplayed = canWalletBeUsed
          ? `${label} + ${wallet.headerText}`
          : label;
        let pType = {
          ...storagePaymentMode,
          name: PAYMENT_METHOD.CITRUS_WALLET,
          label: labelToBeDisplayed,
          paymentId: modeId, // we have show the icon of selected payment mode in case of piggy wallet
          status: "E",
          paymentMode: PAYMENT_METHOD.CITRUS_WALLET,
          img_url: imageUrl,
        };
        dispatch(keyMapsAction.SET_PAYMENT_MODE_TEMP_ACTION, pType || {}, {
          root: true,
        });
      }
    },
    getInitCart({ commit, state, dispatch }, payload) {
      try {
        const isWalletUsed = LocalStorageFunc.getIsWalletUsed();
        const tipCartVariant = Utility.getSessionStorageValue(
          "VWO_TIPCART_VARIANT"
        );
        const dataObj = {
          cartId: LocalStorageFunc.cartId(),
        };
        const headersObj = {
          ...Headers(),
          isWalletUsed,
          tip_variant: tipCartVariant || "NA",
        };
        ApiCalls.GET_INITIAL_CART({
          headers: headersObj,
          payload: dataObj,
        })
          .then(function (res) {
            if (res?.data) {
              if (res.data.status === RESPONSE.SUCCESS) {
                let cartD = res.data;
                commit("Cart/updateCartItemsFromGetCart", res.data, {
                  root: true,
                });
                if (cartD?.calculations) {
                  // Utility.saveCartSuccess(cartD);
                  const explicitPromoObj = get(cartD, "explicitPromo", false);
                  if (
                    explicitPromoObj &&
                    explicitPromoObj.paymentOptions &&
                    explicitPromoObj.paymentOptions.length > 0
                  ) {
                    commit("updateIsExplicitPromoAvailable", true);
                    dispatch(keyMapsAction.BIN_OFFER_SAVE_PAYMENT_API, cartD, {
                      root: true,
                    });
                  } else {
                    commit("updateIsExplicitPromoAvailable", false);
                    commit(
                      keyMapsMutation.UPDATE_PAY_USING_OTHER_PAYMENT_MODE,
                      true,
                      { root: true }
                    );
                    commit("updateCartDataLoaded", true);
                  }
                  if (
                    res?.data?.baseCalculationsMap?.grand_total?.roundedValue
                  ) {
                    cartD.displayPriceWithoutDiscount =
                      res?.data?.baseCalculationsMap?.grand_total?.roundedValue;
                    cartD.displayNetPrice =
                      res?.data?.baseCalculationsMap?.grand_total?.roundedValue;
                    commit(
                      keyMapsMutation.UPDATE_DISPALY_PRICE,
                      cartD.displayPriceWithoutDiscount,
                      {
                        root: true,
                      }
                    );
                  }
                  commit("updateCartData", cartD);
                  commit("updateValidItems", get(cartD, "validItems", []));
                  commit(
                    "Global/updateDisplayPrice",
                    cartD.displayPriceWithoutDiscount,
                    {
                      root: true,
                    }
                  );
                  // changed calculations to calculation for nxg cart service
                  commit("updatecalculations", cartD.calculations);
                  // in case of domino's wallet
                  dispatch("checkIfIsWalletUsed", cartD || {});
                  //Failed Transaction handling
                  const txnStatus = Utility.getSessionStorageValue(
                    "TRANSACTION_STATUS_NEXTGEN_PAYMENT"
                  );
                  if (
                    txnStatus &&
                    txnStatus.transaction &&
                    txnStatus.transaction === "FAILED"
                  ) {
                    let errMsg = txnStatus.msg
                      ? decodeURIComponent(txnStatus.msg).replaceAll("+", " ")
                      : "Something went wrong. Please retry using a different payment option.";
                    console.log("ERROR MSG....", errMsg);
                    let errData = {
                      bodyMsg:
                        "Something went wrong. Please retry using a different payment option.",
                      headerMsg: "Payment Failed",
                    };
                    dispatch("PaymentSubmit/openErrorModalFun", errData, {
                      root: true,
                    });
                    LocalStorageFunc.unsetSessionStorageKey(
                      "TRANSACTION_STATUS_NEXTGEN_PAYMENT"
                    );
                  }
                  //Duplicate Possibility handling
                  const orderStatus = Utility.getSessionStorageValue(
                    "CHECK_DUPLICATE_ORDER_STATUS"
                  );
                  const {
                    duplicateOrderMessage = common.duplicateOrderMessage,
                    duplicatePossibility,
                  } = orderStatus || {};
                  if (orderStatus && duplicatePossibility) {
                    commit(
                      "ErrorModal/updateDuplicateMsg",
                      duplicateOrderMessage,
                      { root: true }
                    );
                    commit("ErrorModal/updateIsDuplicatePossModal", true, {
                      root: true,
                    });
                    LocalStorageFunc.unsetSessionStorageKey(
                      "CHECK_DUPLICATE_ORDER_STATUS"
                    );
                  }
                } else {
                  // ampUtility.dynamicAmplitudeEvent('redirect_payment', {
                  // 	error: 'Empty Cart - Redirect to Cart Page',
                  // 	cartData: JSON.stringify(cartD),
                  // 	Page_Name: "payment_lp",
                  // 	previousScreenname: "cart"
                  // });
                  console.log("Empty Cart - Redirect to Cart Page");
                  //   window.location = "/cart";
                }
              } else {
                let errMsg = common.internalServerError;
                if (res?.data?.errors)
                  errMsg = get(
                    res.data,
                    "errors[0].displayMsg",
                    common.internalServerError
                  );
                const errData = {
                  bodyMsg: errMsg,
                  headerMsg: "",
                  rightCTAText: common.ok,
                };
                // ampUtility.dynamicAmplitudeEvent('get_cart_error', {
                // 	error: 'Get Cart Error1 - ' + errMsg,
                // 	Page_Name: "payment_lp",
                // 	previousScreenname: "cart"
                // });
                commit("ErrorModal/updateRefreshLoadModal", true, {
                  root: true,
                });
              }
            } else if (res?.errors) {
              const err = get(res, "errors[0].", "");
              const errData = {
                bodyMsg: err.displayMsg || "",
                headerMsg: err.header || "",
                rightCTAText: err.btnMsg || common.ok,
              };
              // ampUtility.dynamicAmplitudeEvent('get_cart_error', {
              // 	error: 'Get Cart Error2 - ' + err?.displayMsg,
              // 	Page_Name: "payment_lp",
              // 	previousScreenname: "cart"
              // });
              commit("ErrorModal/updateRefreshLoadModal", true, { root: true });
            } else if (res?.error) {
              const errData = {
                bodyMsg: res.message || "",
                headerMsg: "",
                rightCTAText: common.ok,
              };
              // ampUtility.dynamicAmplitudeEvent('get_cart_error', {
              // 	error: 'Get Cart Error3 - ' + res?.message,
              // 	Page_Name: "payment_lp",
              // 	previousScreenname: "cart"
              // });
              commit("ErrorModal/updateRefreshLoadModal", true, { root: true });
            }
          })
          .catch(function (error) {
            console.log("ERROR in get cart... 101", error);
            const err = get(error, "errors[0]", "");
            const errData = {
              bodyMsg: err.displayMsg || "",
              headerMsg: err.header || "",
              rightCTAText: err.btnMsg || "",
            };
            // ampUtility.dynamicAmplitudeEvent('get_cart_error', {
            // 	error: 'Get Cart Error Catch - ' + err?.displayMsg,
            // 	Page_Name: "payment_lp",
            // 	previousScreenname: "cart"
            // });
            commit("ErrorModal/updateRefreshLoadModal", true, { root: true });
          });
      } catch (err) {
        console.error("ERROR in get cart", err);
        commit("ErrorModal/updateRefreshLoadModal", true, { root: true });
      }
    },
    getInitCartSpecificForPayment({ commit, state, dispatch }, res) {
      try {
        const isWalletUsed = LocalStorageFunc.getIsWalletUsed();
        const tipCartVariant = Utility.getSessionStorageValue(
          "VWO_TIPCART_VARIANT"
        );
        if (res?.data) {
          if (res.data.status === RESPONSE.SUCCESS) {
            let cartD = res.data;
            if (cartD?.calculations) {
              // Utility.saveCartSuccess(cartD);
              const explicitPromoObj = get(cartD, "explicitPromo", false);
              if (
                explicitPromoObj &&
                explicitPromoObj.paymentOptions &&
                explicitPromoObj.paymentOptions.length > 0
              ) {
                commit("updateIsExplicitPromoAvailable", true);
                dispatch(keyMapsAction.BIN_OFFER_SAVE_PAYMENT_API, cartD, {
                  root: true,
                });
              } else {
                commit("updateIsExplicitPromoAvailable", false);
                commit(
                  keyMapsMutation.UPDATE_PAY_USING_OTHER_PAYMENT_MODE,
                  true,
                  { root: true }
                );
                commit("updateCartDataLoaded", true);
              }
              if (res?.data?.baseCalculationsMap?.grand_total?.roundedValue) {
                cartD.displayPriceWithoutDiscount =
                  res?.data?.baseCalculationsMap?.grand_total?.roundedValue;
                cartD.displayNetPrice =
                  res?.data?.baseCalculationsMap?.grand_total?.roundedValue;
                commit(
                  keyMapsMutation.UPDATE_DISPALY_PRICE,
                  cartD.displayPriceWithoutDiscount,
                  {
                    root: true,
                  }
                );
              }
              commit("updateCartData", cartD);
              commit("updateValidItems", get(cartD, "validItems", []));
              commit(
                "Global/updateDisplayPrice",
                cartD.displayPriceWithoutDiscount,
                {
                  root: true,
                }
              );
              // changed calculations to calculation for nxg cart service
              commit("updatecalculations", cartD.calculations);
              // in case of domino's wallet
              dispatch("checkIfIsWalletUsed", cartD || {});
              //Failed Transaction handling
              const txnStatus = Utility.getSessionStorageValue(
                "TRANSACTION_STATUS_NEXTGEN_PAYMENT"
              );
              if (
                txnStatus &&
                txnStatus.transaction &&
                txnStatus.transaction === "FAILED"
              ) {
                let errMsg = txnStatus.msg
                  ? decodeURIComponent(txnStatus.msg).replaceAll("+", " ")
                  : "Something went wrong. Please retry using a different payment option.";
                console.log("ERROR MSG....", errMsg);
                let errData = {
                  bodyMsg:
                    "Something went wrong. Please retry using a different payment option.",
                  headerMsg: "Payment Failed",
                };
                // dispatch("PaymentSubmit/openErrorModalFun", errData, {
                //   root: true,
                // });
                LocalStorageFunc.unsetSessionStorageKey(
                  "TRANSACTION_STATUS_NEXTGEN_PAYMENT"
                );
              }
              //Duplicate Possibility handling
              const orderStatus = Utility.getSessionStorageValue(
                "CHECK_DUPLICATE_ORDER_STATUS"
              );
              const {
                duplicateOrderMessage = common.duplicateOrderMessage,
                duplicatePossibility,
              } = orderStatus || {};
              if (orderStatus && duplicatePossibility) {
                commit("ErrorModal/updateDuplicateMsg", duplicateOrderMessage, {
                  root: true,
                });
                commit("ErrorModal/updateIsDuplicatePossModal", true, {
                  root: true,
                });
                LocalStorageFunc.unsetSessionStorageKey(
                  "CHECK_DUPLICATE_ORDER_STATUS"
                );
              }
            } else {
              // ampUtility.dynamicAmplitudeEvent('redirect_payment', {
              // 	error: 'Empty Cart - Redirect to Cart Page',
              // 	cartData: JSON.stringify(cartD),
              // 	Page_Name: "payment_lp",
              // 	previousScreenname: "cart"
              // });
              console.log("Empty Cart - Redirect to Cart Page");
              //   window.location = "/cart";
            }
          } else {
            let errMsg = common.internalServerError;
            if (res?.data?.errors)
              errMsg = get(
                res.data,
                "errors[0].displayMsg",
                common.internalServerError
              );
            const errData = {
              bodyMsg: errMsg,
              headerMsg: "",
              rightCTAText: common.ok,
            };
            // ampUtility.dynamicAmplitudeEvent('get_cart_error', {
            // 	error: 'Get Cart Error1 - ' + errMsg,
            // 	Page_Name: "payment_lp",
            // 	previousScreenname: "cart"
            // });
            // commit("ErrorModal/updateRefreshLoadModal", true, {
            //   root: true,
            // });
          }
        } else if (res?.errors) {
          const err = get(res, "errors[0].", "");
          const errData = {
            bodyMsg: err.displayMsg || "",
            headerMsg: err.header || "",
            rightCTAText: err.btnMsg || common.ok,
          };
          // ampUtility.dynamicAmplitudeEvent('get_cart_error', {
          // 	error: 'Get Cart Error2 - ' + err?.displayMsg,
          // 	Page_Name: "payment_lp",
          // 	previousScreenname: "cart"
          // });
          // commit("ErrorModal/updateRefreshLoadModal", true, { root: true });
        } else if (res?.error) {
          const errData = {
            bodyMsg: res.message || "",
            headerMsg: "",
            rightCTAText: common.ok,
          };
          // ampUtility.dynamicAmplitudeEvent('get_cart_error', {
          // 	error: 'Get Cart Error3 - ' + res?.message,
          // 	Page_Name: "payment_lp",
          // 	previousScreenname: "cart"
          // });
          // commit("ErrorModal/updateRefreshLoadModal", true, { root: true });
        }
      } catch (err) {
        console.error("ERROR in get cart", err);
        commit("ErrorModal/updateRefreshLoadModal", true, { root: true });
      }
    },
  },
};
